import { createRoute, redirect } from '@tanstack/react-router';
import {
  ForgottenPasswordRoute,
  RegisterInviteRoute,
  ResetPasswordRoute,
  TeamMemberRegisterRoute,
  TwoFactorChallengeRoute,
} from '../common';
import { publicRoute } from '../layouts';

// Public pages: `auth: false` and not guest-only, so they hang off the root with no guard.

// Reached mid-login while answering a 2FA challenge.
export const twoFactorChallengeRoute = createRoute({
  getParentRoute: () => publicRoute,
  path: '/two-factor-challenge',
  component: TwoFactorChallengeRoute,
  staticData: { title: 'Two-Factor Authentication' },
});

export const registerTeamMemberRoute = createRoute({
  getParentRoute: () => publicRoute,
  path: '/register-team-member',
  component: TeamMemberRegisterRoute,
  staticData: { title: 'Register Team Member' },
});

export const registerInviteRoute = createRoute({
  getParentRoute: () => publicRoute,
  path: '/register-invite',
  component: RegisterInviteRoute,
  staticData: { title: 'Invite to Register' },
});

export const forgottenPasswordRoute = createRoute({
  getParentRoute: () => publicRoute,
  path: '/forgotten-password',
  component: ForgottenPasswordRoute,
  staticData: { title: 'Forgotten Password' },
});

export const resetPasswordRoute = createRoute({
  getParentRoute: () => publicRoute,
  path: '/reset-password/$token',
  component: ResetPasswordRoute,
  staticData: { title: 'Reset Password' },
});

/**
 * The sales pipeline's tracked registration link. Stamps the registration source onto the query and
 * hands over to `/register`; not guest-only itself, so a logged-in visitor is bounced home by the
 * guest guard on the way through.
 */
export const salesRegisterRoute = createRoute({
  getParentRoute: () => publicRoute,
  path: '/go-register',
  beforeLoad({ location }) {
    throw redirect({
      to: '/register',
      search: {
        ...(location.search as Record<string, unknown>),
        app_registration_source: 'sales_pipeline_tracked_link',
      },
    });
  },
  staticData: { title: 'Register - Sales Pipeline Redirect' },
});
